export default __webpack_public_path__ + "static/media/screen4.9604f2e2.png";